<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="6">
          <b-col md="6 mt-3 float-right">
            <b-button
              variant="primary"
              class="mb-2 float-right btn-custom"
              @click="showModal('Add')"
              ><font-awesome-icon icon="plus"
            /></b-button>
          </b-col>
        </b-col>
      </b-row>
      <paginated-table
        ref="dataTable"
        :can-edit="false"
        :can-delete="false"
        :can-approve="false"
        :can-reject="false"
        :can-show="false"
        :can-edit-modal="true"
        :can-paid="false"
        :data-url="apiUrl.stockArea"
        v-on:editData="doEdit"
        :data-key="dataKey"
        :data-columns="columns"
      >
        <!-- v-on:editData="doEdit" -->
      </paginated-table>
    </b-card>
    <b-modal ref="my-modal" centered hide-footer title='Add Stock Area'>
      <form v-on:submit.prevent="doSubmit">
        <label for="" class="mt-2 labels">Code *</label>
        <b-form-input
          type="text"
          class="mb-1"
          v-model="model.areaCode"
          placeholder="Enter Code"
          name="areaCode"
          v-bind:class="errors.has('areaCode') ? 'is-invalid' : ''"
          v-validate="'required'"
        ></b-form-input>
        <label for="" class="mt-2 labels">Name *</label>
        <b-form-input
          type="text"
          class="mb-1"
          v-model="model.areaName"
          placeholder="Enter Area Name"
          name="areaName"
          v-bind:class="errors.has('areaName') ? 'is-invalid' : ''"
          v-validate="'required'"
        ></b-form-input>
        <label for="" class="mt-2 labels">address *</label>
        <input
          type="text"
          class="mb-1 form-control"
          v-model="model.areaAddress"
          placeholder="Enter address"
          name="areaAddress"
          v-bind:class="errors.has('areaAddress') ? 'is-invalid' : ''"
          v-validate="'required'"
        />
        <label for="" class="mt-2 labels">phone </label>
        <input
          type="text"
          v-model="model.areaPhone"
          class="mb-1 form-control"
          placeholder="Enter Phone"
        />
        <label for="" class="mt-2 labels">fax</label>
        <input
          type="text"
          v-model="model.areaFax"
          class="mb-1 form-control"
          placeholder="Enter Fax"
        />
        <label for="" class="mt-2 labels">account code *</label>
        <div
          class="form-group d-flex"
          style="height: 2.25rem"
        >
          <b-input
            list="journals"
            v-model="model.selectedJournalAccount"
            name="selectedJournalAccount"
            v-bind:class="errors.has('selectedJournalAccount') ? 'has-error' : ''"
            v-validate="'required'"
            placeholder="Journal Account"
            style="height: 100%"
            required
          />
          <datalist id="journals">
            <option
              v-for="(journal, index) in journalAccountList"
              :key="index"
              :value="journal.text"
            />
          </datalist>
          <p v-if="errors.has('selectedJournalAccount') !== null"></p>
        </div>
         <label for="" class="mt-2 labels">Note </label>
        <input
          type="text"
          v-model="model.areaNote"
          class="mb-1 form-control"
          placeholder="Enter Note"
        />
      

        <b-button class="mt-3" variant="secondary" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
        <b-button class="mt-3 float-right" variant="primary" type="submit"
          ><font-awesome-icon icon="save"></font-awesome-icon
          >{{ this.model.uuid !== null ? ' Update' : ' Save' }}
        </b-button>
      </form>
    </b-modal>
        <!-- <edit-worksheet-type-modal ref="editWorksheetType" v-on:getWorksheetType="getWorksheetType"></edit-worksheet-type-modal> -->
        <edit-stock-area ref="editStockArea" v-on:getStockArea="getStockArea"></edit-stock-area>
  </div>
</template>

<script>
import PaginatedTable from '../../../components/PaginatedTable.vue';
// import EditWorksheetTypeModal from './EditWorksheetTypeModal.vue';
import EditStockArea from './EditStockArea.vue'
export default {
  name: 'worksheet-type',
  components: {
     PaginatedTable,
     EditStockArea
    },
  data() {
    return {
      dataKey: 'stock_area',
      isLoading: false,
      apiUrl: {
        stockArea: window.AppConfig.apiUrl + 'stock-area', 
        journal: window.AppConfig.apiUrl + 'journal-account',
      },
      type: null,
      model: {
        uuid: null,
        areaCode: null,
        areaName: null,
        areaAddress: null,
        areaPhone:null,
        areaFax:null,
        areaNote: null,
        journalAccount: null,
        selectedJournalAccount: ''
      },
      journalAccountList: [],
      columns: [
        {
          key: 'areaCode',
          label: 'Code',
          sortable: true,
        },
        {
          key: 'areaName',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'areaAddress',
          label: 'Address',
          sortable: true,
        },
        {
          key: 'areaPhone',
          label: 'Phone',
          sortable: true,
        },
        {
          key: 'areaFax',
          label: 'Fax',
          sortable: true,
        },
        {
          key: 'journalAccount.journalAccountName',
          label: 'Account Code',
          sortable: true,
        },
        {
          key: 'actionTypes',
          label: '',
        },
      ],
    };
  },
  mounted() {
    this.getStockArea();
    this.fetchJournalAccount()
  },
  methods: {
    getStockArea() {
      this.isLoading = true;
      this.$refs.dataTable.getDataTable();
    },
    doSubmit() {
      this.$validator.validateAll().then((res) => {
        let selected = this.model.selectedJournalAccount;
        this.model.journalAccount = this.journalAccountList.find(journal=> {
          return journal.text === selected
        })?.value ?? null;
        if (res) {
          if (this.model.uuid !== null) {
            this.$http
              .patch(this.apiUrl.stockArea + '/' + this.model.uuid, {
                  areaCode: this.model.areaCode,
                  areaName: this.model.areaName,
                  areaAddress: this.model.areaAddress,
                  areaPhone: this.model.areaPhone,
                  areaFax: this.model.areaFax,
                  areaNote: this.model.areaNote,
                  journalAccount: this.model.journalAccount
              })
              // eslint-disable-next-line no-unused-vars
              .then((response) => {
                this.$store.dispatch('notification/success', 'Worksheet type has been updated.');
                this.$refs.dataTable.doFilter();
                this.hideModal();
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          } else {
            if(this.model.journalAccount !==null || this.model.journalAccount !==''){
              console.log('yg dkirim:', this.model);
              this.$http
                .post(this.apiUrl.stockArea, {
                  areaCode: this.model.areaCode,
                  areaName: this.model.areaName,
                  areaAddress: this.model.areaAddress,
                  areaPhone: this.model.areaPhone,
                  areaFax: this.model.areaFax,
                  areaNote: this.model.areaNote,
                  journalAccount: this.model.journalAccount
                })
                // eslint-disable-next-line no-unused-vars
                .then((response) => {
                  this.$store.dispatch('notification/success', 'Stock Area has been added.');
                  this.$refs.dataTable.doFilter();
                  this.hideModal();
                })
                .catch((error) => {
                  this.$store.dispatch('notification/error', error);
                });
            }
          }
        }
      });
    },
    showModal() {
      this.model.areaCode = null
      this.model.areaName  = null
      this.model.areaAddress  = null
      this.model.areaPhone = null
      this.model.areaFax = null
      this.model.areaNote = null
      this.model.journalAccount = null
      this.$validator.reset();
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    doEdit(row) {
      this.$refs.editStockArea.showModal(row);
    },
    doShowModal(row) {
      this.$refs.editStockArea.showModal(row);
    },

    fetchJournalAccount(){
      this.$http.get(this.apiUrl.journal + '?journalAccountType=D').then(resp=>{
        this.journalAccountList = []
        resp.data._embedded.journal_account.forEach(journal=>{
          this.journalAccountList.push({
            value: journal.uuid,
            text: journal.journalAccountType + ' - ' + journal.journalAccountCode + ' - ' + journal.journalAccountName
          })
        })
      }).catch(error => console.log(error))
    }
  },
};
</script>
